import styled from 'styled-components';
import theme from '../../styles/defaultTheme';

export const Container = styled.div`
    display: flex;
    align-items: center;
    max-width: 2000px;
    justify-content: center;
    margin: 0 0 32px 0;
`;

export const ContainerMobile = styled.div`
    display: flex;
    flex-direction: column;
    margin: 24px 16px;
`;

export const StepMobile = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
`;

export const StepDescription = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    & label {
        font-weight: bold;
        font-size: ${theme.font.size16};
    }

    & span {
        color: ${(props) => props.theme.grey};
        font-size: ${theme.font.size12};
    }
`;

export const ProgressBar = styled.progress`
    width: 100%;
    height: 4px;
    margin-top: 12px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &::-webkit-progress-value {
        background-color: ${(props) => props.theme.orange};
    }
    
    &::-webkit-progress-bar {
        background-color: ${(props) => props.theme.lightGrey40};
    }

    &::-webkit-progress-value,
    &::-webkit-progress-bar {
        border-radius: 8px;
    }
`;

export const Step = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 50px;

    &[data-status="finished"] div {
        border: 1px solid ${(props) => props.theme.orange};
        background: ${(props) => props.theme.orange};
        color: ${(props) => props.theme.white};
    }

    &[data-status="active"] div {
        border: 1px solid ${(props) => props.theme.orange};
        color: ${(props) => props.theme.black};
        background: ${(props) => props.theme.white};
        font-weight: bold;
    }

    &[data-status="pending"] div {
        border: 1px solid ${(props) => props.theme.lightGrey40};
        background: ${(props) => props.theme.white};
        color: ${(props) => props.theme.lightGrey40};
        font-weight: bold;
        
        
    }

    &[data-status="pending"] label {
        color: ${(props) => props.theme.grey};
        font-weight: normal;
    }
`;

export const Circle = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    font-weight: bold;
    font-size: ${theme.font.size24};
    border: 1px solid ${(props) => props.theme.orange};
    background-color: ${(props) => props.theme.white};

    &.mobile {
        margin-right: 16px;
    }
`;

export const Label = styled.label`
    margin: 10px 0 0;
    white-space: nowrap;
    width: fit-content;
    text-align: center;
    font-weight: bold;
    font: ${theme.font.body[6]};
    letter-spacing: 0px;
    color: ${(props) => props.theme.grey};
`;

export const Divider = styled.div`
    height: 5px;
    min-width: 46px;
    background: ${(props) => props.theme.lightGrey40};
    border-radius: 10px;
    margin: 0 40px 35px;

    &[data-status="finished"] {
        background: ${(props) => props.theme.orange} 0% 0% no-repeat padding-box;
    }
`;
